import { IApiService } from './IApiService';
import { ApiService } from './ApiService';
import apiResponse, { ApiResponse } from './ApiResponse';
import { SectionView } from '../views/DashboardView';
import { Section } from '../models/Survey';

/**
 * The questionnaire sitting due now, as one drawer section in the same shape as a
 * survey section. No sitting due: sittingId is null, sections empty.
 */
export interface DueQuestionnaireView {
  kind: 'questionnaire';
  sittingId: number | null;
  sections: Section[];
}

export interface SubmitQuestionnaireResult {
  sittingId: number;
  completedAt: string;
  completedDay: number | null;
}

export class QuestionnaireSittingStore {
  constructor(private readonly api: IApiService = new ApiService()) {}

  public async GetDue(cohortId: number): Promise<ApiResponse<DueQuestionnaireView>> {
    try {
      const response = await this.api.get(`/Cohort/${cohortId}/questionnaireSittings/due`);
      return apiResponse.Success<DueQuestionnaireView>(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async SubmitAnswers(
    cohortId: number,
    sittingId: number,
    section: SectionView
  ): Promise<ApiResponse<SubmitQuestionnaireResult>> {
    try {
      const cleanSection: SectionView = {
        id: section.id,
        name: section.name,
        description: section.description,
        questions: section.questions,
      };
      const response = await this.api.post(`/Cohort/${cohortId}/questionnaireSittings/${sittingId}/answers`, {
        sectionView: cleanSection,
      });
      return apiResponse.Success<SubmitQuestionnaireResult>(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
